import React, { useContext } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useHttp } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/contexts';
import { setToLocalStorage } from 'src/utils';

interface Props {
  label: React.ReactNode;
  type: React.ReactNode;
  planId?: string;
  currencyId?: string;
}
const GoogleLoginButton: React.FC<Props> = ({ label, type, planId, currencyId }) => {
  const { sendRequest: apiRequestHandler, isLoading: isLoading, error } = useHttp();
  const { accessToken, setAccessToken } = useContext(AuthContext);
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: response => {
      if (type === 'signup') {
        apiRequestHandler(
          {
            method: 'POST',
            url: `auth/google/signup`,
            payload: {
              accessToken: response.access_token,
              priceId: planId,
              currencyId: currencyId,
            },
          },
          (data: any) => {
            setToLocalStorage(`::@@adlyJwtAuthspajs@@::`, data); //todo need to change this
            setAccessToken(data.accessToken);
            navigate('/sign-up?step=3');
          },
        );
      }

      if (type === 'login') {
        apiRequestHandler(
          {
            method: 'POST',
            url: `auth/google/login`,
            payload: { accessToken: response.access_token },
          },
          (data: any) => {
            setToLocalStorage(`::@@adlyJwtAuthspajs@@::`, data);
            setAccessToken(data.accessToken);
            // navigate('/booking');
            navigate('/sign-up?step=3');
          },
        );
      }

      // Handle successful login response
    },
    onError: () => {
      console.error('Login Failed');
      // Handle login error
    },
  });

  return (
    <button
      type="button"
      className="w-full mt-4 bg-white border border-gray-300 text-gray-700 py-2 rounded flex items-center justify-center"
      onClick={() => login()}
    >
      <img
        src="https://img.icons8.com/color/16/000000/google-logo.png"
        alt="Google"
        className="mr-2"
      />
      {label}
    </button>
  );
};

export default GoogleLoginButton;
